'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _confirmRegistration = require('./confirmRegistration.component');

var _confirmRegistration2 = _interopRequireDefault(_confirmRegistration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var confirmRegistrationModule = _angular2.default.module('confirmRegistration', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('confirmRegistration', {
    url: '/confirmRegistration/:key',
    component: 'confirmRegistration',
    params: {
      key: null
    }
  });
}).component('confirmRegistration', _confirmRegistration2.default).name;

exports.default = confirmRegistrationModule;


// WEBPACK FOOTER //
// ./client/app/components/confirmRegistration/confirmRegistration.js